import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; // Make sure you have react-icons installed
import './WhatsAppFloatingButton.css'; // We'll create this CSS file next

function WhatsAppFloatingButton() {
  // Replace '+91461008161' with your actual WhatsApp number, including the country code
  const whatsappNumber = '+919461008161'; 
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  return (
    <a
      href={whatsappLink}
      className="whatsapp_floating_button"
      target="_blank" // Opens in a new tab
      rel="noopener noreferrer" // Security best practice for target="_blank"
      aria-label="Chat with us on WhatsApp" // Accessibility label
    >
      <FaWhatsapp />
    </a>
  );
}

export default WhatsAppFloatingButton;